import { apiGet } from '@/lib/api';
import { pricebookKeys } from '@/lib/queryKeys';
import { useApiQuery } from '../useApiQuery';
import { usePricebookApi } from './usePricebookApi';
import type { PricebookItemUsage } from '@/types/pricebook';

/**
 * Where-used counts (in packages / used on estimates / used on jobs) for a
 * line item. Powers the detail Summary Card metrics (NOT-103).
 */
export function usePricebookItemUsage(id: string) {
  const { client, ep } = usePricebookApi();
  return useApiQuery<PricebookItemUsage>({
    queryKey: pricebookKeys.usage(id),
    queryFn: () => apiGet<PricebookItemUsage>(client, ep.usage(id)),
    enabled: Boolean(id),
    showErrorToast: false,
    staleTime: 60 * 1000,
  });
}
